import React, { useState } from 'react';
import { CloudData } from '../data/cloud-data.js';
import { Configuration } from '../data/configuration.js';
import FormInput from './ui/form-input.tsx';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface LoadConfigurationViewProps {
	onConfigurationDataLoaded: () => void;
	onBackButtonClicked: () => void;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export function LoadConfigurationView(props: LoadConfigurationViewProps) {

	// states.
	const [input, setInput] = useState('');
	const [message, setMessage] = useState('');
	const [enableButton, setEnableButton] = useState(true);

	// handlers.

	const handleInputChange = (id: string, value: string) => {
		setInput(value);
	};

	const handleSubmitButtonClicked = () => {

		// trim the entered short code and ensure it's not blank.
		const shortCode = input.trim();
		if (shortCode) {

			// disable the button.
			setEnableButton(false);

			// load configuration data from the cloud.
			CloudData.loadConfiguration(shortCode)

				// if successful, update the costs and call the callback fn.
				.then(() => {
					Configuration.updateCosts();
					props.onConfigurationDataLoaded();
				})

				// or, display a message and re-enable the button if the operation fails.
				.catch((error) => {
					console.error(error);
					setMessage('Invalid code');
					setEnableButton(true);
				});
		}
	};

	// return the HTML.
	return (
		<div id="load-view">
			<div id="load-content">
				<FormInput
					handleUpdateInput={handleInputChange}
					inputValue={input}
					input={{ id: 'text', placeholder: 'YOUR CODE' }}
				/>
				<button type="button" id="lv-submit-button" disabled={!enableButton} onClick={handleSubmitButtonClicked}>
					{enableButton ? 'SUBMIT' : 'LOADING...'}
				</button>
				<p id="lv-message">
					{message}
				</p>
			</div>
			<div id="load-footer">
				<button type="button" onClick={props.onBackButtonClicked}>
					BACK
				</button>
			</div>
		</div>
	);
}
